// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
// console.log('Vite ⚡️ Rails')
// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>
// console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')
// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')
// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'
import './util/jquery';
import 'core-js';
// Needed for sign out actions interestingly enough
// https://github.com/rails/jquery-ujs#installation-using-rails-and-webpacker
import 'jquery-ujs';
import ReactGA from 'react-ga';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';

// Allows using window.Modernizr
import 'shared/vendor/modernizr-custom';

import './application.scss';

// Import all channels.
import.meta.glob('./**/*_channel.js', { eager: true });

if (window.IH && window.IH.googleAnalyticsKey) {
  ReactGA.initialize(window.IH.googleAnalyticsKey);
}
